module.exports = __webpack_public_path__ + "a3d650e56bded53439c3977f65ac97fa.png";